<!--!&#45;&#45; Hero Start &ndash;&gt;-->
<section class="bg-half-170 d-table w-100" id="home"
         style="background: url('assets/3r/WhatsApp Image 2021-07-26 at 10.19.24 AM.jpeg') center center; background-size: cover">
    <div class="bg-overlay"></div>
    <div class="container">

        <div class="row align-items-center">
            <div class="col-lg-7 col-md-6">
                <div class="title-heading mt-4">
                    <h1 class="display-4 font-weight-bold text-white title-dark mb-3">Best Air Ticketing Services in Sri
                        Lanka</h1>
                    <p class="para-desc text-white-50">With years of experience in the Tourism & Travel industry, 3R
                        Travels is committed to providing you with a speedy & comprehensive air ticketing services in
                        Sri Lanka.</p>
                    <!--                    <div class="mt-4">-->
                    <!--                        <a href="javascript:void(0)" class="btn btn-icon btn-pills btn-lg btn-light">-->
                    <!--                            <i-feather name="arrow-down" class="icons"></i-feather>-->
                    <!--                        </a>-->
                    <!--                    </div>-->
                </div>
            </div>
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>
<!--end section-->
<div class="position-relative">
    <div class="shape overflow-hidden text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
        </svg>
    </div>
</div>
<!-- Hero End -->

<section class="section">
    <div class="container">
        <div *ngIf="package==null" class="row justify-content-center">
            <mat-spinner></mat-spinner>
        </div>
                <h4>Ticketing</h4>
                <div class="mt-4 row" *ngIf="package.length !=0 || package !=null">
                    <div class="col-xl-4 col-lg-4 mb-3" *ngFor="let p of package">
                        <div class="card img shadow-md" style=" background: url({{p.url}});border-radius: 10px">
                            <div class="bg-overlay" style="border-radius: 10px"></div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12">
                                        <h4 style="color: white">{{p.title}}</h4>
                                        <p class="text-muted">{{p.origin.country}} - {{p.destination.country}}</p>
                                    </div>
                                    <div class="col-12">
                                        <button class="btn btn-primary" style=" margin-top: 31px;"  (click)="booking(p)"> book now</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>


        <div  *ngIf="package.length ==0 || package ==null">
            <div class="mt-4 row">
                <div class="col-3 mb-3">
                    <div class="card shadow rounded border-0 overflow-hidden">
                        <img src="assets/3r/sl.jpg" class="img-fluid" alt="">
                        <div class="card-body">
                            <h5 class="card-title">Sri lankan Airlines</h5>
                        </div>
                    </div>
                </div>
                <div class="col-3 mb-3">
                    <div class="card shadow rounded border-0 overflow-hidden">
                        <img src="assets/3r/qatar.png" class="img-fluid" alt="">
                        <div class="card-body">
                            <h5 class="card-title">Qatar Airways</h5>
                        </div>
                    </div>
                </div>
                <div class="col-3 mb-3">
                    <div class="card shadow rounded border-0 overflow-hidden">
                        <img src="assets/3r/singapoor.png" class="img-fluid" alt="">
                        <div class="card-body">
                            <h5 class="card-title">Singapore Airlines</h5>
                        </div>
                    </div>
                </div>

                <div class="col-3 mb-3">
                    <div class="card shadow rounded border-0 overflow-hidden">
                        <img src="assets/3r/AirNewZealand_500x500.jpg" class="img-fluid" alt="">
                        <div class="card-body">
                            <h5 class="card-title">Air NewZealand</h5>
                        </div>
                    </div>
                </div>
                <div class="col-3 mb-3">
                    <div class="card shadow rounded border-0 overflow-hidden">
                        <img src="assets/3r/austrian.gif" class="img-fluid" alt="">
                        <div class="card-body">
                            <h5 class="card-title">Austrian Airline</h5>
                        </div>
                    </div>
                </div>
                <div class="col-3 mb-3">
                    <div class="card shadow rounded border-0 overflow-hidden">
                        <img src="assets/3r/turki.jpg" class="img-fluid" alt="">
                        <div class="card-body">
                            <h5 class="card-title">Turkish Airlines</h5>
                        </div>
                    </div>
                </div>
                <div class="col-3 mb-3">
                    <div class="card shadow rounded border-0 overflow-hidden">
                        <img src="assets/3r/malesia.gif" class="img-fluid" alt="">
                        <div class="card-body">
                            <h5 class="card-title">Malaysia Airlines</h5>
                        </div>
                    </div>
                </div>
                <div class="col-3 mb-3">
                    <div class="card shadow rounded border-0 overflow-hidden">
                        <img src="assets/3r/emitres.png" class="img-fluid" alt="">
                        <div class="card-body">
                            <h5 class="card-title">Emirates Airlines</h5>
                        </div>
                    </div>
                </div>
                <div class="col-3 mb-3">
                    <div class="card shadow rounded border-0 overflow-hidden">
                        <img src="assets/3r/lufthansa.png" class="img-fluid" alt="">
                        <div class="card-body">
                            <h5 class="card-title">Lufthansa Airlines</h5>
                        </div>
                    </div>
                </div>
                <div class="col-3 mb-3">
                    <div class="card shadow rounded border-0 overflow-hidden">
                        <img src="assets/3r/china.png" class="img-fluid" alt="">
                        <div class="card-body">
                            <h5 class="card-title">Air China</h5>
                        </div>
                    </div>
                </div>
                <div class="col-3 mb-3">
                    <div class="card shadow rounded border-0 overflow-hidden">
                        <img src="assets/3r/dubay.jpg" class="img-fluid" alt="">
                        <div class="card-body">
                            <h5 class="card-title">Fly Dubai</h5>
                        </div>
                    </div>
                </div>
                <div class="col-3 mb-3">
                    <div class="card shadow rounded border-0 overflow-hidden">
                        <img src="assets/3r/kuwait.jpg" class="img-fluid" alt="">
                        <div class="card-body">
                            <h5 class="card-title">Kuwait Airways</h5>
                        </div>
                    </div>
                </div>
                <div class="col-3 mb-3">
                    <div class="card shadow rounded border-0 overflow-hidden">
                        <img src="assets/3r/airasia.png" class="img-fluid" alt="">
                        <div class="card-body">
                            <h5 class="card-title">Air Asia</h5>
                        </div>
                    </div>
                </div>
                <div class="col-3 mb-3">
                    <div class="card shadow rounded border-0 overflow-hidden">
                        <img src="assets/3r/cathy.png" class="img-fluid" alt="">
                        <div class="card-body">
                            <h5 class="card-title">Cathay Pacific</h5>
                        </div>
                    </div>
                </div>
                <div class="col-3 mb-3">
                    <div class="card shadow rounded border-0 overflow-hidden">
                        <img src="assets/3r/malindo.jpg" class="img-fluid" alt="">
                        <div class="card-body">
                            <h5 class="card-title">Malindo Airways</h5>
                        </div>
                    </div>
                </div>
                <div class="col-3 mb-3">
                    <div class="card shadow rounded border-0 overflow-hidden">
                        <img src="assets/3r/india.gif" class="img-fluid" alt="">
                        <div class="card-body">
                            <h5 class="card-title">Air India</h5>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>

</section>


<!-- Modal Content Start -->
<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="modal-basic-title">Package details</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="bg-white p-3 rounded box-shadow">
            <h4>{{details.packageName}}</h4>
            <p class="text-secondary">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Atque culpa debitis
                dolorum est ex id iure labore modi nesciunt numquam odio omnis pariatur qui saepe vitae, voluptate,
                voluptatem voluptatibus voluptatum!</p>
            <p class="text-primary">{{details.packageStartDate}}  to  {{details.packageEndDate}}</p>
            <p>{{details.noOfDays}} Days</p>
            <h6>itenary</h6>
            <p class="text-secondary" *ngFor="let d of details.itenary">{{d.description}}</p>
            <br>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Close</button>
    </div>
</ng-template>
<!-- Modal Content End -->

<!--end col-->
<!-- Modal End -->
